import { create } from 'zustand';
import { getTour } from './tours';

interface PendingTour {
  tourId: string;
  identity: string;
  fromPath: string;
  fromKey: string;
  destination: string;
}

/** In-memory navigation intent only; never survives a login or browser reload. */
export const usePendingTourStore = create<{
  pending: PendingTour | null;
  request: (tourId: string, identity: string, fromPath: string, fromKey: string) => string | null;
  clear: () => void;
}>((set) => ({
  pending: null,
  request: (tourId, identity, fromPath, fromKey) => {
    const tour = getTour(tourId);
    if (!identity || !tour?.paths[0]) return null;
    const destination = tour.entryRoute ?? tour.paths[0];
    set({ pending: { tourId, identity, fromPath, fromKey, destination } });
    return destination;
  },
  clear: () => set({ pending: null }),
}));

export const tourLaunchIdentity = (actorId: string | undefined, effectiveId: string | undefined, impersonating: boolean): string =>
  actorId && effectiveId ? `${actorId}:${effectiveId}:${impersonating}` : '';
